  import { ViewPollComponent } from './view-poll/view-poll.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';

import { PagesComponent } from './pages.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ViewLoginComponent } from './view-login/view-login.component';
import { ViewLoginPostComponent } from './view-login-post/view-login-post.component';
import { RegisterComponentComponent } from './register-component/register-component.component';
import { RecoveryPasswordComponent } from './recovery-password/recovery-password.component';
import { AuthGuardService } from '../services/auth-guard.service';
import { CreateOfferComponent } from './create-offer/create-offer.component';
import { ViewEventComponent } from './view-event/view-event.component';
import { ViewNotificationComponent } from './view-notification/view-notification.component';
import { MessageComponent } from './message/message.component';
import { CheckDocsComponent } from './check-docs/check-docs.component';
import { CheckDocListComponent } from './check-doc-list/check-doc-list.component';
import { ViewVenueComponent } from './view-venue/view-venue.component';
import { ViewFormComponent } from './view-form/view-form.component';
import { SearchCandidatesComponent } from './search-candidates/search-candidates.component';
import { SearchCandidatesMapComponent } from './search-candidates-map/search-candidates-map.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { MapComponent } from './map/map.component';
import { ListOfferComponent } from './list-offer/list-offer.component';
import { ListOfferContractComponent } from './list-offer-contract/list-offer-contract.component';
import { ListRequisitionComponent } from './list-requisition/list-requisition.component';
import { ViewInviteComponent } from './view-invite/view-invite.component';
import { ViewJobComponent } from './view-job/view-job.component';
import { ViewJobContractComponent } from './view-job-contract/view-job-contract.component';
import { ViewTransactionComponent } from './view-transaction/view-transaction.component';
import { CvComponent } from './cv/cv.component';
import { ReportsComponent } from './reports/reports.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { BlockchainComponent } from './blockchain/blockchain.component';
import { WalletComponent } from './wallet/wallet.component';


let mainPage = 'dashboard';
const role = localStorage.getItem('role');
if (role == 'contracts') {
  mainPage = 'listoffercontract';
}
const routes: Routes = [
  { path: 'login-post', component: ViewLoginPostComponent },
  { path: 'login', component: ViewLoginComponent },
  { path: 'login/:token', component: ViewLoginComponent },
  { path: 'register', component: RegisterComponentComponent },
  { path: 'recovery', component: RecoveryPasswordComponent },
    {
    path: 'pages',
    component: PagesComponent,
    // canActivate: [LoginService],
    children: [
      { path: 'dashboard', component: DashboardComponent, pathMatch: 'full' },
      { path: 'createoffer/requisition/:reqId', component: CreateOfferComponent, canActivate: [AuthGuardService] },
      { path: 'createoffer/:id', component: CreateOfferComponent, canActivate: [AuthGuardService]},
      { path: 'createoffer', component: CreateOfferComponent, canActivate: [AuthGuardService]},
      { path: 'viewevent', component: ViewEventComponent, canActivate: [AuthGuardService]},
      { path: 'viewevent/:jobId', component: ViewEventComponent, canActivate: [AuthGuardService]},
      { path: 'viewevent/:jobId/:userId', component: ViewEventComponent, canActivate: [AuthGuardService]},
      { path: 'viewnotification', component: ViewNotificationComponent, canActivate: [AuthGuardService]},
      { path: 'viewoffer/:id', component: CreateOfferComponent, canActivate: [AuthGuardService]},
      { path: 'message', component: MessageComponent, canActivate: [AuthGuardService] },
      { path: 'blockchain', component: BlockchainComponent, canActivate: [AuthGuardService] },
      { path: 'checkdocs/:jobId/:userId', component: CheckDocsComponent, canActivate: [AuthGuardService] },
      { path: 'checkdoclist', component: CheckDocListComponent, canActivate: [AuthGuardService] },
      { path: 'form', component: ViewFormComponent, canActivate: [AuthGuardService] },
      { path: 'poll', component: ViewPollComponent, canActivate: [AuthGuardService] },
      { path: 'venue', component: ViewVenueComponent, canActivate: [AuthGuardService] },
      { path: 'candidates', component: SearchCandidatesComponent, canActivate: [AuthGuardService] },
      { path: 'candidates_map', component: SearchCandidatesMapComponent, canActivate: [AuthGuardService] },
      { path: 'candidates/:jobId', component: SearchCandidatesComponent, canActivate: [AuthGuardService] },
      { path: 'invite/:jobId', component: SearchCandidatesComponent, canActivate: [AuthGuardService] },
      { path: 'configuration', component: ConfigurationComponent, canActivate: [AuthGuardService] },
      { path: 'map', component: MapComponent, canActivate: [AuthGuardService] },
      { path: 'listoffer', component: ListOfferComponent, canActivate: [AuthGuardService] },
      { path: 'listoffercontract', component: ListOfferContractComponent, canActivate: [AuthGuardService] },
      { path: 'listofferfreelancer', component: ListRequisitionComponent, canActivate: [AuthGuardService] },
      { path: 'viewinvite/:jobId', component: ViewInviteComponent, canActivate: [AuthGuardService] },
      { path: 'viewjob/:jobId', component: ViewJobComponent, canActivate: [AuthGuardService] },
      { path: 'wallet/:jobId', component: WalletComponent, canActivate: [AuthGuardService] },
      { path: 'viewjobcontract/:jobId', component: ViewJobContractComponent, canActivate: [AuthGuardService] },
      { path: 'viewtransaction', component: ViewTransactionComponent, canActivate: [AuthGuardService] },
      { path: 'listofferpremium', component: ListOfferComponent, canActivate: [AuthGuardService] },
      { path: 'cv/:userId/job/:jobId', component: CvComponent, canActivate: [AuthGuardService] },
      { path: 'reports', component: ReportsComponent, canActivate: [AuthGuardService] },
      { path: 'reports/:jobId', component: ReportsComponent, canActivate: [AuthGuardService] },
      { path: '', redirectTo: mainPage, pathMatch: 'full' },
      { path: '**', component: PageNotFoundComponent }    ]
  },
  { path: '**', redirectTo: '/pages/' + mainPage, pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/pages-routing.module.ts